module.exports = __webpack_public_path__ + "img/tu_3.d0caf7c6.png";